const _ = require("lodash");
const {atTempUser} = require("./StateCursors");
const {setIn} = require("../../../shared/ImmHelpers");
const DEMO_PROFILE_SETTINGS = require("../../../shared/data/demoProfile.json")
	.profileUser.model.settings;

const init = (type = null, dataVersion = null) => ({
	dataVersion,
	type,
	model: {
		settings: DEMO_PROFILE_SETTINGS,
		lastPlayedData: {},
	},
});

// Create a new temp user if none found or if it is not of the same type being requested
const getTempUser = function(state, storage, type, dataVersion = null) {
	const localTempUserData = storage.getItem("tempUserData");
	const localSharedProblems = storage.getItem("tempSharedProblems");
	if (localSharedProblems) {
		state.sharedProblemModels = _.extend(
			state.sharedProblemModels,
			JSON.parse(localSharedProblems)
		);
	}
	const currentData = atTempUser(state).get();
	const currentDataType = _.get(currentData, "type");
	const currentDataVersion = _.get(currentData, "dataVersion");
	const isOutdated =
		dataVersion && (!currentDataVersion || currentDataVersion < dataVersion);
	if (currentDataType !== type) {
		const localData = JSON.parse(localTempUserData);
		if (localData && localData.type === type) {
			state = atTempUser(state).set(localData);
		} else {
			state = atTempUser(state).set(init(type, dataVersion));
		}
	} else if (isOutdated) {
		state = atTempUser(state).set(init(type, dataVersion));
	}
	return state;
};

const saveLocalTempUserData = function(state, storage) {
	// Special care needs to be taken when saving data that uses load guards
	// Any pending states that get saved may cause "stuck" pages
	let tempUserData = atTempUser(state).get();
	if (_.get(tempUserData, ["library", "pages"])) {
		tempUserData = setIn(
			tempUserData,
			["library", "pages", "loadedPages"],
			lp => _.omitBy(lp, page => page.load !== "done")
		);
		tempUserData = setIn(
			tempUserData,
			["library", "pages", "loadingPageNumber"],
			null
		);
	}
	storage.setItem("tempUserData", JSON.stringify(tempUserData));
	if (state.sharedProblemModels)
		storage.setItem(
			"tempSharedProblems",
			JSON.stringify(state.sharedProblemModels)
		);
	return state;
};

const clearTempUser = function(state, storage) {
	state = atTempUser(state).set(init());
	storage.removeItem("tempUserData");
	state.sharedProblemModels = {};
	storage.removeItem("tempSharedProblems");
	return state;
};

module.exports = {
	init,
	getTempUser,
	clearTempUser,
	saveLocalTempUserData,
};
